import { withStyles, withTheme } from "@material-ui/core";
import React from "react";
import { compose } from "recompose";
import StyledToolTip from "../../../../../../common/StyledToolTip";
import { getSvgIcons, getThemeColorByIconName } from "../../../../utils/iconsUtil";

const styles = () => ({
  iconsContainer: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  iconStyle: {
    marginRight: 5,
  },
});

const PickupTypesRenderer = (props) => {
  const options = props.context?.pickupTypeOptions;
  const { classes, value } = props;
  const pickupsTypes = options.filter((item) => value.includes(item.value));
  if (pickupsTypes.length === 0) {
    return null;
  }

  const getIcon = (iconType) => {
    const theme = props.theme;
    if (iconType.icon) {
      return <i className={`${iconType.icon}`} />;
    }
    if (iconType.svgIcon) {
      const {backgroundColor, borderColor=""} = getThemeColorByIconName(iconType, theme);
      return getSvgIcons({
        iconName: iconType.svgIcon,
        backgroundColor,
        borderColor,
        size: iconType?.iconStyles?.size
      });
    }
    return null;
  };

  return (
    <div className={classes.iconsContainer}>
      {pickupsTypes.map((iconType, index) => (
        <StyledToolTip key={index} title={iconType.tooltip}>
          <div className={classes.iconStyle}>{getIcon(iconType)}</div>
        </StyledToolTip>
      ))}
    </div>
  );
};

export default compose(withTheme(), withStyles(styles))(PickupTypesRenderer);
